<template>
    <div class="">
        <div class="">
            <div class="spacer s30"></div>

            <div v-if="granted" class="container">
                <div v-if="vesselCreated">
                    <div class="bold">Vessel Created</div>
                    <div class="spacer s10"></div>
                    <div class="buttons">
                        <span class="button is-primary is-medium" @click="viewNewVesselProfilePage()">
                            <font-awesome-icon icon="link" /> &nbsp; View New Vessel Profile Page
                        </span>
                    </div>
                </div>
                <div v-else>
                    <div class="field">
                        <label class="label">Vessel name</label>
                        <input class="input padded" type="text" placeholder="Enter vessel name..." v-model="newVessel.name" />
                    </div>
                    <div class="spacer s10"></div>
                    <div class="field">
                        <label class="label">Vessel UVI</label>
                        <input class="input padded" type="text" placeholder="Unique identifier..." v-model="newVessel.uvi" />
                    </div>
                    <div class="spacer s10"></div>
                    <div class="field">
                        <label class="label">Vessel location</label>
                        <input class="input padded" type="text" placeholder="Vessel location..." v-model="newVessel.location" />
                    </div>
                    <div class="spacer s10"></div>
                    <div class="field">
                        <label class="label">Vessel description</label>
                        <textarea class="textarea padded" type="text" placeholder="Type a description..." v-model="newVessel.description"></textarea>
                    </div>
                    <div class="spacer s10"></div>

                    <div class="upload-container">
                        <label class="label">Avatar</label>
                        <vue2Dropzone
                            ref="imgDropZone1"
                            id="customdropzone1"
                            :options="dropzoneOptions"
                            @vdropzone-complete="(response) => afterComplete(response, true)"></vue2Dropzone>
                    </div>
                    <div class="spacer s30"></div>

                    <div class="upload-container">
                        <label class="label">Gallery</label>
                        <vue2Dropzone
                            ref="imgDropZone2"
                            id="customdropzone2"
                            :options="dropzoneOptions"
                            @vdropzone-complete="(response) => afterComplete(response, false)"></vue2Dropzone>
                    </div>

                    <hr />

                    {{ newVessel }}

                    <hr />

                    <div v-if="newVessel.gallery.length > 0">
                        <ul>
                            <li v-for="(img, idx) in newVessel.gallery" :key="`img-${idx}`">
                                <img :src="img" />
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="spacer s100"></div>
                <div class="spacer s100"></div>

                <div class="buttons floating">
                    <button :disabled="!canSave" class="button is-medium is-primary" @click="saveNewAsset()">
                        <font-awesome-icon icon="plus" /> &nbsp; Save New Vessel
                    </button>
                </div>
            </div>

            <div v-else class="container">
                <div v-if="attempts > 4" class="bold">Access Denied</div>

                <div v-else>
                    <div class="field">
                        <input :disabled="checking" class="input padded" type="text" placeholder="Enter code" maxlength="10" v-model="accessCode" />
                    </div>
                    <div class="spacer s10"></div>
                    <p v-if="checking" class="loading-spinner"><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Checking code...</p>
                    <div v-else class="buttons centered">
                        <button class="button is-info mt-1" :disabled="accessCode == '' || checking" @click="openGate()">Open Sesame</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '../main.js';
import { collection, doc, arrayUnion, query, updateDoc, getDoc, setDoc, getDocs, addDoc } from 'firebase/firestore';
// const SimpleModal = () => import('../reusables/SimpleModal.vue');
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import NProgress from 'nprogress';

const functions = getFunctions();
const addVesselRevision = httpsCallable(functions, 'addVesselRevision');
const sendAnyEmail = httpsCallable(functions, 'sendAnyEmail');
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
// let uuid = require('uuid');
// import { v4 as uuidv4 } from 'uuid';
const { v4: uuidv4 } = require('uuid');
import draggable from 'vuedraggable';

export default {
    mounted() {
        this.getCodes();
        this.newVessel.id = uuidv4();
    },

    components: {
        vue2Dropzone
    },

    computed: {
        canSave() {
            // return true;
            return (
                this.newVessel.name !== '' &&
                this.newVessel.avatar !== '' &&
                this.newVessel.uvi !== '' &&
                this.newVessel.location !== '' &&
                this.newVessel.description !== ''
            );
        }
    },

    data() {
        return {
            checking: false,
            granted: false,
            accessCode: '',
            attempts: 0,
            appCodes: [],
            newVessel: {
                id: '',
                code: '',
                name: '',
                uvi: '',
                avatar: '',
                location: '',
                description: '',
                gallery: []
            },
            tempImage: '',
            dropzoneOptions: {
                url: 'https://httpbin.org/post',
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                addRemoveLinks: true,
                acceptedFiles: '.jpg, .jpeg, .png',
                dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Click here to add a photo</p><p class="form-text">Allowed Files: .jpg, jpeg, .png (Up to 4MB)</p>`,
                maxFilesize: 4
            },
            vesselCreated: false
        };
    },

    methods: {
        close() {},

        async getCodes() {
            NProgress.start();
            const q = query(collection(db, 'appInfo', 'randomData', 'goAppCodes'));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                this.appCodes.push(doc.data().code);
            });
            setTimeout(() => {
                NProgress.done();
            }, 100);
        },

        openGate() {
            this.checking = true;
            this.attempts++;
            const code = this.accessCode.trim().toLowerCase();
            // console.log('code', code);
            if (this.appCodes.includes(code)) {
                this.granted = true;
                this.checking = false;
                this.accessCode = '';
                this.attempts = 0;
            } else {
                this.checking = false;
                this.accessCode = '';
                if (this.attempts > 4) {
                    this.granted = false;
                }
            }
        },

        async afterComplete(file, isAvatar) {
            // console.log(file);
            let self = this;
            let imageName = uuidv4();
            NProgress.start();
            try {
                let storage = getStorage();
                let imageRef = storageRef(storage, `temp-assets/${self.newVessel.id}/${imageName}.png`);
                uploadBytes(imageRef, file).then((snapshot) => {
                    getDownloadURL(snapshot.ref).then((downloadURL) => {
                        if (isAvatar) {
                            self.newVessel.avatar = downloadURL;
                        } else {
                            if (self.newVessel.gallery.length < 5) {
                                self.newVessel.gallery.push(downloadURL);
                            }
                        }
                    });
                });
                NProgress.done();
            } catch (error) {
                console.log(error);
                NProgress.done();
            }
            setTimeout(() => {
                NProgress.done();
            }, 1000);
        },

        deleteImage(index) {
            this.imageChanged = true;
            this.newVessel.gallery.splice(index, 1);
        },

        // pasted:
        async saveNewAsset() {
            // console.log(this.newVessel);
            // need to create the new asset in the new customer sales machine fleet
            // need to get the 6 digit code
            // need to send an email to Steve with the new asset details and 6 digit code in the subject (JSON stringify in email body)
            // need button with _blank link to the new asset profile in go..

            NProgress.start();
            let t = new Date();
            let endData = t.setDate(t.getDate() + 365);

            // Generate a random 6 digit number as a string
            // If it's already in vesselManualCodes in database, try again
            let tryAgain = true;
            let randomNumString;
            while (tryAgain) {
                randomNumString = Math.floor(Math.random() * 1000000)
                    .toString()
                    .padStart(6, '0');
                const docRef = doc(this.db, 'vesselManualCodes', randomNumString);
                const docSnap = await getDoc(docRef);
                if (!docSnap.exists()) {
                    // This is what we want
                    tryAgain = false;
                }
            }
            this.newVessel.code = randomNumString;

            // Add the entry to vesselManualCodes in database
            setDoc(doc(this.db, 'vesselManualCodes', randomNumString), {
                manualCode: randomNumString,
                vesselID: this.newVessel.id,
                vesselName: this.newVessel.name
            });

            // create new vessel array and create new vessel document in the database
            let newVesselArray = {
                vesselName: this.newVessel.name,
                vesselUVI: this.newVessel.uvi,
                homePort: this.newVessel.location,
                avatarUrl: this.newVessel.avatar ?? '',
                isDemo: false,
                isPaidFor: true,
                lastVesselCharge: 0,
                nextVesselCharge: 0,
                nextChargeDate: new Date(endData),
                vesselOwnerID: 'bae4eb5a-d542-40a6-b27f-86e6cb63024f',
                vesselOwnerName: 'OffshoreSMS Free Vessels',
                isCompanyVessel: true,
                aaaPlans: ['logs'],
                isActive: false,
                isExpired: false,
                auditVessel: false,
                isPrivate: false,
                takesPassengers: false,
                dateAdded: new Date(),
                addedBy: 'OffshoreSMS Team',
                isFreebie: false,
                platform: 'go',
                inductionCycle: 365,
                assetType: 'vessel',
                vesselManualCode: randomNumString
            };
            await setDoc(collection(this.db, 'vessels', this.newVessel.id), newVesselArray);

            // add to list of sales machine fleet vessels
            let fleetAssetData = {
                vesselOwnerID: 'bae4eb5a-d542-40a6-b27f-86e6cb63024f',
                vesselOwnerName: 'OffshoreSMS Free Vessels',
                vesselName: this.newVessel.name,
                vesselUVI: this.newVessel.uvi,
                vesselID: this.newVessel.id,
                vesselState: this.newVessel.location,
                dateAdded: new Date()
            };
            await setDoc(doc(this.db, 'companies/bae4eb5a-d542-40a6-b27f-86e6cb63024f/companyVessels', this.newVessel.id), fleetAssetData);

            // create a new default role for the vessel Master
            await addDoc(collection(this.db, 'vessels', this.newVessel.id, 'assetRoles'), {
                title: 'Master',
                accessLevel: 2,
                statements: [],
                notifications: [],
                users: ['3wTzZecD4QYOPUk4IyWRA2JmDcJ2'],
                dateCreated: new Date(),
                createdBy: 'OffshoreSMS Team',
                index: 1,
                archived: false
            });

            // add new vessel ID to steve's vesselsThatICrew
            await updateDoc(this.db, 'userdata', '3wTzZecD4QYOPUk4IyWRA2JmDcJ2', {
                vesselsThatICrew: arrayUnion(this.newVessel.id)
            });

            // add steve's userid to vessel's listOfCrewIDs
            await updateDoc(this.db, 'vessels', this.newVessel.id, {
                listOfCrewIDs: arrayUnion('3wTzZecD4QYOPUk4IyWRA2JmDcJ2')
            });

            // add revision to new vessel's history
            addVesselRevision({
                userName: 'OffshoreSMS Team',
                userID: '',
                vesselName: this.newVessel.name,
                vesselID: this.newVessel.id,
                revisionDetails: 'New marine asset ' + this.newVessel.name + ' added by the OffshoreSMS Team',
                revisionCode: ''
            });

            // send email to Steve
            sendAnyEmail({
                recipients: ['help@offshoresms.com.au'],
                message: 'New sales machine vessel called ' + this.newVessel.name + ' added: ' + this.newVessel.code,
                subject: this.newVessel.name + ' [' + this.newVessel.code + '] added in OffshoreSMS Free Vessels'
            });

            // !display link to new go page for the new vessel
            // GO link

            // update initial vessel warning cycles
            setTimeout(() => {
                NProgress.done;
                this.updateCycles();
                this.vesselCreated = true;
            }, 1000);
        },

        async updateCycles() {
            let selfInductions = [
                { slug: 'statements', label: 'Responsibility Statements' },
                { slug: 'contacts', label: 'General Contacts' },
                { slug: 'policies', label: 'Policies' },
                { slug: 'sops', label: 'Safe Work Procedures' },
                { slug: 'eops', label: 'Emergency Procedures' },
                { slug: 'hazards', label: 'Hazards & Risk Assessments' }
            ];
            let inductionCycle = 365;

            await setDoc(
                doc(this.db, 'vessels/' + this.newVessel.id + '/warningCycles', 'generalInductions'),
                {
                    type: 'induction',
                    id: 'induction',
                    cycle: parseInt(inductionCycle),
                    title: 'General Induction',
                    updated: new Date()
                },
                { merge: true }
            );

            await Promise.all(
                selfInductions.map(async (m) => {
                    const docRef = doc(this.db, 'vessels', this.newVessel.id, 'warningCycles', m.slug);
                    await setDoc(
                        docRef,
                        {
                            type: 'self-induction',
                            id: m.slug,
                            cycle: parseInt(inductionCycle),
                            title: m.label,
                            updated: new Date()
                        },
                        { merge: true }
                    );
                })
            );
        },

        viewNewVesselProfilePage() {
            let newVesselLink = 'https://go.offshoresms.com.au/vessel/?c=' + this.newVessel.code;
            window.open(newVesselLink, '_blank');
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    text-align: left;
}
@media only screen and (max-width: 479px) {
}
</style>
